// 안내문 QR 주소 검사 — http(s) 만 받는다. 비우면 QR 칸을 뺀다.

export const NOTICE_QR_MAX = 300;

export type NoticeQrUrl =
  | { kind: "empty" }
  | { kind: "ok"; url: string }
  | { kind: "invalid"; reason: string };

const SCHEME = /^([a-z][a-z0-9+.-]*):/i;

export const normalizeNoticeQrUrl = (raw: string): NoticeQrUrl => {
  const text = raw.trim();
  if (text === "") return { kind: "empty" };
  if (text.length > NOTICE_QR_MAX) return { kind: "invalid", reason: `주소가 너무 깁니다(${NOTICE_QR_MAX}자 이내)` };
  if (/\s/.test(text)) return { kind: "invalid", reason: "주소에 띄어쓰기가 있습니다" };
  const scheme = SCHEME.exec(text);
  // 「example.com:8080」 처럼 스킴 없이 포트만 붙은 주소는 https 로 본다.
  const bare = scheme === null || /^[^/]+:\d+(\/|$)/.test(text);
  const candidate = bare ? `https://${text}` : text;
  if (!bare && !/^https?:$/i.test(`${scheme?.[1]}:`)) {
    return { kind: "invalid", reason: "http 나 https 로 시작하는 주소만 넣을 수 있습니다" };
  }
  let url: URL;
  try {
    url = new URL(candidate);
  } catch {
    return { kind: "invalid", reason: "주소 형식이 아닙니다" };
  }
  if (url.protocol !== "http:" && url.protocol !== "https:") {
    return { kind: "invalid", reason: "http 나 https 로 시작하는 주소만 넣을 수 있습니다" };
  }
  if (url.username !== "" || url.password !== "") return { kind: "invalid", reason: "아이디·비밀번호가 든 주소는 넣을 수 없습니다" };
  if (!url.hostname.includes(".") || url.hostname.endsWith(".")) return { kind: "invalid", reason: "도메인이 빠졌습니다" };
  if (url.href.length > NOTICE_QR_MAX) return { kind: "invalid", reason: `주소가 너무 깁니다(${NOTICE_QR_MAX}자 이내)` };
  return { kind: "ok", url: url.href };
};
